import script from "./SecNotIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./SecNotIcon.vue?vue&type=script&setup=true&lang=js"

import "./SecNotIcon.vue?vue&type=style&index=0&id=5b3be8b8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b3be8b8"]])

export default __exports__